export default function CWriteFiles() {
  return <h2>C Write Files</h2>;
}
